import { useEffect, useState } from 'react';
import Button from '../../components/button/Button';
import LinkButton from '../../components/button/LinkButton';
import InputField from '../../components/inputField/InputField';
import ScreenContainer from '../../components/layout/ScreenContainer';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { SignupAPI } from '../../logic/signupApi/signupApi';
import ErrorMessage from '../../components/errorMessage/ErrorMessage';
import Loader from '../../components/loader/Loader';
import { setCookie } from '../../utils/cookie-typescript-utils';
import { useTranslation } from 'react-i18next';

const EmailScreen = () => {
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();

  const { register, handleSubmit, formState: { errors } } = useForm();

  const [linkRef, setLinkRef] = useState<string | null>(null);

  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = (data: any) => {
    setIsLoading(true);

    let email = data.email.trim();

    SignupAPI.sendLoginCode({
      whereToSendTheCode: 'email',
      email: email.trim(),
      language: i18n.language
    }).then(() => {
      navigate("verification", { state: { email: email } })
      setIsLoading(false);
    }).catch((error: any) => {
      console.log('error while sending login code: ', error);
      setIsLoading(false);

      if (error.opCode) {

        switch (error.opCode) {
          case 'auth/user-not-found':
            console.log("Navigate to registration with email: ", email);
            navigate(`/signup${linkRef ? `?ref=${linkRef}`: ''}`, { state: { email: email } });
            break;

          default:
            break;
        }
      }
      else {
        setErrMsgTxt(error.message);
        setErrMsgVisible(true);
      }
    });
  };

  const [errMsgVisible, setErrMsgVisible] = useState(false);
  const [errMsgTxt, setErrMsgTxt] = useState('');

  const email = useLocation().state?.email || null;
  const filledEmail = useLocation().state?.filledEmail || null;
  const phone = useLocation().state?.phone || null;

  const [sessionTimeoutVisible, setSessionTimeoutVisible] = useState(() => {
    if (typeof window === 'undefined') return false;
    return new URLSearchParams(window.location.search).get('error') === 'session-timeout';
  });

  useEffect(()=>{
    const urlParams = new URLSearchParams(window.location.search);
    const goTo = urlParams.get('goto');
    if(goTo){
      setCookie('goTo', goTo);
    }

    const link = urlParams.get('ref');
    if(link) {
      setLinkRef(link);
    }
  }, []);

  return (
    <ScreenContainer pageTitle={t('PAGE_TITLE_LOGIN')}>
      {
        sessionTimeoutVisible && (
          <ErrorMessage
            message={t('SESSION_TIMEOUT_MESSAGE')}
            onClose={() => {
              setSessionTimeoutVisible(false);
              const search = new URLSearchParams(window.location.search);
              search.delete('error');
              const q = search.toString();
              window.history.replaceState({}, '', window.location.pathname + (q ? '?' + q : ''));
            }}
          />
        )
      }
      {
        errMsgVisible && <ErrorMessage message={errMsgTxt} onClose={() => { setErrMsgVisible(false); }} />
      }

      <h2 className='size-h2 u-mb-1 u-text-bold'>{t('WELCOME')}!</h2>
      <h3 className='size-h3 u-mb-2 u-text-bold'>
        {email ? t('IS_YOUR_EMAIL') : t('WHAT_IS_EMAIL')}
      </h3>

      <form onSubmit={handleSubmit(onSubmit)}>
        <InputField
          name="email"
          errors={errors}
          register={register}
          autoFocus
          large
          options={{
            required: true,
            pattern: {
              value: /\s*^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\s*$/i,
              message: t('INVALID_EMAIL')
            },
            validate: {
              minLength: (v) => v.length >= 0,
            }
          }}
          placeholder={t('EMAIL_ADDRESS')}
          defaultValue={email || filledEmail}
        />
        {isLoading && <Loader />}
        <Button title={t('CONTINUE')} />
      </form>

      <LinkButton
        title={t('EMAIL_SCREEN_TEXT_FIRST')}
        onClick={() => navigate(`/login/phone${linkRef ? `?ref=${linkRef}`: ''}`, { state: { email: email, phone } })}
      />
      <LinkButton
        title={t('DONT_HAVE_ACCOUNT')}
        onClick={() => navigate(`/signup${linkRef ? `?ref=${linkRef}` : ''}`, { state: { email: email } })}
      />
    </ScreenContainer>
  )
};

export default EmailScreen